export default "__VITE_ASSET__COtJJOTH__"